function countComboListPrice(product) {
	let total = 0
	if (product.comboSelect?.length > 0) {
		product.comboSelect.forEach(e => {
			e.details.forEach(({ detail, optionSelect }) => {
				total += detail.price * detail.count
				total += optionSelect.reduce(
					(c, d) => c + d.reduce((a, b) => a + b.optionDetailSelect.price, 0),
					0,
				)
			})
		})
	}
	return total * product.count
}

function countUpgradeListPrice(product) {
	let total = 0
	if (product.upgradeListId) {
		total += product.upgradePrice
		product.upgradeSelect?.forEach(e => {
			e.upgradeContentDetails.forEach(
				({ upgradeContentDetail, optionSelect }) => {
					total += upgradeContentDetail.price * upgradeContentDetail.count
					total += optionSelect.reduce(
						(c, d) => c + d.reduce((a, b) => a + b.optionDetailSelect.price, 0),
						0,
					)
				},
			)
		})
	}
	return total * product.count
}

function countOptionPrice(product) {
	const { count, optionSelect } = product
	return (
		optionSelect?.reduce(
			(a, b) => a + b.optionDetailSelect.count * b.optionDetailSelect.price,
			0,
		) * count || 0
	)
}

// 遠離零進位：正值同 Math.ceil，負值進位到絕對值較大的整數，
// 使折後小計 = sign(基準) × (|基準| − trunc(折抵))；Math.ceil 對負值會往零收，不可直接用
export function ceilAwayFromZero(value) {
	return value < 0 ? -Math.ceil(-value) : Math.ceil(value)
}

// 取得商品細項總計
export function countProductPrice(product) {
	const { count, itemPrice, price } = product
	const isOrder = itemPrice == null
	const initialPrice = isOrder ? price : itemPrice
	return (
		countOptionPrice(product) +
		count * initialPrice +
		countUpgradeListPrice(product) +
		countComboListPrice(product)
	)
}

// 取得商品實收(小計)
export function countProductAmountReceive(product) {
	const { count, itemPrice, price, discountPrice = 0 } = product
	const isOrder = itemPrice == null
	const initialPrice = isOrder ? price : itemPrice
	return ceilAwayFromZero(
		countOptionPrice(product) +
			count * (initialPrice - discountPrice) +
			countUpgradeListPrice(product) +
			countComboListPrice(product),
	)
}

function countOrderComboListPrice(product) {
	let total = 0
	if (product.comboList?.length > 0) {
		product.comboList.forEach(combo => {
			total += combo.price * combo.count
			if (combo.optionList?.length) {
				combo.optionList.forEach(
					option => (total += option.price * option.count),
				)
			}
		})
	}
	return total
}

function countOrderUpgradeListPrice(product) {
	let total = 0
	if (product.upgradeListId) {
		total += product.upgradePrice
		product.upgradeSelect?.forEach(e => {
			total += e.upgradeContentDetail.price * e.upgradeContentDetail.count
			total += e.upgradeContentDetail.optionSelect.reduce(
				(c, d) => c + d.reduce((a, b) => a + b.optionDetailSelect.price, 0),
				0,
			)
		})
	}
	return total
}

const countOrderOptionPrice = product => {
	let total = 0
	product.optionList?.forEach(option => {
		total += option.count * option.price
	})
	return total
}

export function countOrderPrice(product) {
	const { count, itemPrice, price } = product
	const isOrder = itemPrice == null
	const initialPrice = isOrder ? price : itemPrice
	return (
		countOrderOptionPrice(product) +
		count * initialPrice +
		countOrderUpgradeListPrice(product) +
		countOrderComboListPrice(product)
	)
}

export function getOrderTotal(order) {
	return order?.reduce((p, e) => p + countOrderPrice(e), 0) || 0
}

export function getCartTotal(order) {
	return order?.reduce((p, e) => p + countProductAmountReceive(e), 0) || 0
}

// 將購物車內容轉變成 新增訂單的 orderDetailList參數
export function getOrderDetailList(cart) {
	let list = []
	cart.forEach(item => {
		list.push({
			itemId: item.itemId,
			count: item.count,
			discountPrice: 0,
			entertain: false,
			freeItem: item.freeItem,
			remark: item.itemRemark,
			upgradeId: item.upgradeListId,
			optionList: item.optionSelect?.map(option => {
				return {
					optionId: option.id,
					optionDetailId: option.optionDetailSelect.id,
					count: option.optionDetailSelect.count,
				}
			}),
			upgradeList: item.upgradeSelect?.reduce((upgradeList, upgrade) => {
				const upgradeObj = []
				upgrade.upgradeContentDetails.forEach(
					({ upgradeContentDetail, optionSelect }) => {
						for (let i = 0; i < upgradeContentDetail.count; i++) {
							upgradeObj.push({
								contentId: upgrade.upgradeContentId,
								itemId: upgradeContentDetail.itemId,
								optionList: optionSelect[i]?.map(option => {
									return {
										optionId: option.id,
										optionDetailId: option.optionDetailSelect.id,
										count: option.optionDetailSelect.count,
									}
								}),
							})
						}
					},
				)
				return [...upgradeList, ...upgradeObj]
			}, []),
			comboList: item.comboSelect?.reduce((comboList, combo) => {
				const comboObj = []
				combo.details.forEach(({ detail, optionSelect }) => {
					for (let i = 0; i < detail.count; i++) {
						comboObj.push({
							contentId: combo.id,
							itemId: detail.itemId,
							optionList: optionSelect[i]?.map(option => {
								return {
									optionId: option.id,
									optionDetailId: option.optionDetailSelect.id,
									count: option.optionDetailSelect.count,
								}
							}),
						})
					}
				})
				return [...comboList, ...comboObj]
			}, []),
		})
	})
	return list
}

export function isUpgradeContentAllNotSale(upgradeContent) {
	const find = upgradeContent.upgradeContentDetailList.find(
		detail => detail.itemStatus && detail.availableForSale,
	)
	return !find
}

export function isComboContentAllNotSale(comboContent) {
	const find = comboContent.detailList.find(
		detail => detail.itemStatus && detail.availableForSale,
	)
	return !find
}

// 尋找購物車金額可用的訂單自動折扣
export function findUseOrderAutomaticDiscount(
	cartTotal,
	orderAutomaticDiscountList,
) {
	let select
	orderAutomaticDiscountList.forEach(automaticDiscount => {
		if (cartTotal >= automaticDiscount.minimumSpendingAmount) {
			if (
				!select ||
				automaticDiscount.minimumSpendingAmount > select.minimumSpendingAmount
			) {
				select = automaticDiscount
			}
		}
	})

	return select
}

// 尋找購物車金額下一個尚未達標最低滿額金額的自動折扣
export function findNextOrderAutomaticDiscount(
	cartTotal,
	orderAutomaticDiscountList,
) {
	let select
	orderAutomaticDiscountList.forEach(automaticDiscount => {
		if (cartTotal < automaticDiscount.minimumSpendingAmount) {
			if (
				!select ||
				automaticDiscount.minimumSpendingAmount < select.minimumSpendingAmount
			) {
				select = automaticDiscount
			}
		}
	})

	return select
}

/**
 * 訂單折抵後的應付金額，夾在 0 以上。
 *
 * 折抵可能剛好等於或超過商品總額（金額型折抵、贈品全額折抵），
 * 負數應付對客人沒有意義，也送不進金流。
 */
export function getOrderPayableTotal(cartTotal, orderAutomaticDiscountPrice) {
	return Math.max(0, (cartTotal || 0) - (orderAutomaticDiscountPrice || 0))
}

// 折抵是否已吃滿整筆訂單（應付 0），用於提示客人不是畫面算錯
export function isDiscountCappedAtZero(cartTotal, orderAutomaticDiscountPrice) {
	return (
		(cartTotal || 0) > 0 &&
		getOrderPayableTotal(cartTotal, orderAutomaticDiscountPrice) === 0
	)
}

// 取得訂單自動折扣減免金額
export function calOrderAutomaticDiscountPrice(
	cartTotal,
	useOrderAutomaticDiscount,
) {
	if (useOrderAutomaticDiscount.discountType === 'AMOUNT') {
		// 折抵不得超過基準：折抵大於總額時只折到 0，不製造負數總計
		const base = Math.max(0, cartTotal || 0)
		return Math.min(useOrderAutomaticDiscount.discountAmount, base)
	}

	if (useOrderAutomaticDiscount.discountType === 'PERCENTAGE') {
		// 不使用小數點進行加減，會導致精度不準確
		// 折抵對基準絕對值計算、恆為非負，折扣不得變加價
		const base = Math.abs(cartTotal)
		return (
			base -
			Math.ceil(
				base * (useOrderAutomaticDiscount.discountPercentage * 0.01).toFixed(2),
			)
		)
	}
	if (useOrderAutomaticDiscount.discountType === 'FREE_ITEM') {
		return 0
	}
}

/**
 * 依商品自動折扣清單算出該筆購物車項目應套用的折扣欄位。
 *
 * 抽成純函數是為了讓初始化、「接受新價」與「重新選購」共用同一份公式 ——
 * 只改 itemPrice 而不重算 discountPrice，會讓 PERCENTAGE 折抵停留在舊價基數
 * （countProductAmountReceive 以 initialPrice - discountPrice 計算實收）。
 *
 * PERCENTAGE 刻意不取整：數量複數時由 countProductAmountReceive 統一遠離零進位。
 *
 * @param {object} item 購物車項目（需含 itemId、itemPrice）
 * @param {object[]} itemAutomaticDiscountList 商品自動折扣清單
 * @returns {object|null} 要覆蓋回 item 的折扣欄位；null 代表不由此處決定（贈品）
 */
export function resolveItemAutomaticDiscount(item, itemAutomaticDiscountList) {
	// 贈品的折抵由訂單自動折扣全額處理，不套商品折扣
	if (item?.freeItem) {
		return null
	}

	let discountItemId = null
	const matched = (itemAutomaticDiscountList || []).find(automaticDiscount =>
		automaticDiscount.automaticDiscountItemList?.find(discountItem => {
			if (discountItem.itemId === item.itemId) {
				discountItemId = discountItem.id
				return true
			}
			return false
		}),
	)

	if (!matched) {
		return {
			automaticDiscountId: null,
			automaticDiscountName: null,
			automaticDiscountItemId: null,
			discountPrice: null,
		}
	}

	const base = {
		automaticDiscountId: matched.id,
		automaticDiscountName: matched.name,
		automaticDiscountItemId: discountItemId,
	}

	if (matched.discountType === 'AMOUNT') {
		return { ...base, discountPrice: matched.discountAmount }
	}

	if (matched.discountType === 'PERCENTAGE') {
		return {
			...base,
			discountPrice:
				item.itemPrice -
				item.itemPrice * (0.01 * matched.discountPercentage).toFixed(2),
		}
	}

	// FREE_ITEM：商品層不決定折抵金額，維持既有值
	return { ...base, discountPrice: item.discountPrice ?? null }
}

const DEFAULT_ADD_ORDER_ERROR_MESSAGE = '新增訂單異常!請刷新再試'
const DEFAULT_SERVICE_ERROR_MESSAGE = '服務異常，請聯繫相關人員'
const GLOBALLY_HANDLED_ERROR_STATUSES = new Set([401, 403, 503])

const MENU_STALE_ERROR_CODES = new Set([
	// 商品
	'ORDER_FAIL_ITEM_STATUS_FALSE',
	'ORDER_FAIL_ITEM_FRONT_SHOW_FALSE',
	'ORDER_ITEM_DISCONTINUED',
	'ORDER_ITEM_REMAINING_AMOUNT',
	'ORDER_ITEM_STOCK_CHANGED',
	'ITEM_NOT_FOUND',
	// 口味
	'ORDER_FAIL_NOT_OPTION',
	'ORDER_FAIL_ADD_OPTION',
	'OPTION_STATUS_FALSE',
	'OPTION_DETAIL_STATUS_FALSE',
	'OPTION_DETAIL_DISCONTINUED',
	'OPTION_VALID_ERROR',
	'OPTION_NOT_FOUND',
	'OPTION_DETAIL_NOT_FOUND',
	'ORDER_ITEM_OPTION_UNLINKED',
	// 套餐
	'ORDER_FAIL_COMBO_CONTENT_EMPTY',
	'ORDER_FAIL_COMBO_CONTENT_VALID_ERROR',
	'ITEM_COMBO_CONTENT_NOT_FOUND',
	'ITEM_COMBO_CONTENT_DETAIL_NOT_FOUND',
	// 升級
	'ORDER_FAIL_UPGRADE_STATUS_FALSE',
	'ORDER_FAIL_UPGRADE_CONTENT_EMPTY',
	'ORDER_FAIL_UPGRADE_CONTENT_VALID_ERROR',
	'ORDER_FAIL_ITEM_UPGRADE_IS_NOT_ASSOCIATION',
	'UPGRADE_SERIES_NOT_FOUND',
	'UPGRADE_SERIES_CONTENT_NOT_FOUND',
	'UPGRADE_SERIES_CONTENT_DETAIL_NOT_FOUND',
	// 贈品
	'ORDER_FREE_ITEM_INVALID',
])

export function isMenuStaleError(errorCode) {
	return MENU_STALE_ERROR_CODES.has(errorCode)
}

export function normalizeAddOrderError(error) {
	const detail = typeof error === 'object' && error !== null ? error : {}
	const stringMessage = typeof error === 'string' ? error : ''

	return {
		message: detail.message || stringMessage || DEFAULT_ADD_ORDER_ERROR_MESSAGE,
		errorCode: detail.errorCode,
		status: detail.status,
	}
}

export function buildServiceRejection(response, fallbackMessage) {
	const rejectWithDetail = response?.config?.rejectWithDetail
	const message =
		response?.data?.message ||
		fallbackMessage ||
		(rejectWithDetail
			? DEFAULT_ADD_ORDER_ERROR_MESSAGE
			: DEFAULT_SERVICE_ERROR_MESSAGE)

	if (!rejectWithDetail) {
		return message
	}

	return normalizeAddOrderError({
		message,
		errorCode: response?.data?.errorCode,
		status: response?.status,
	})
}

export async function handleAddOrderError(error, compareCart) {
	const normalizedError = normalizeAddOrderError(error)
	if (isMenuStaleError(normalizedError.errorCode)) {
		let comparison
		try {
			comparison = await compareCart()
		} catch (err) {
			return { type: 'COMPARE_FAILED' }
		}

		if (comparison?.status === 1) {
			return {
				type: 'MENU_STALE',
				message: comparison.message || normalizedError.message,
			}
		}
	}
	if (GLOBALLY_HANDLED_ERROR_STATUSES.has(normalizedError.status)) {
		return { type: 'HANDLED_GLOBALLY' }
	}

	return { type: 'ERROR', message: normalizedError.message }
}
